import NullData from "./src/index.vue"
import { withInstall } from "@pureadmin/utils"

export const WEmpty = withInstall(NullData)

export default WEmpty
